import * as React from 'react';

import { PresenceContext } from './PresenceContext';

import { useHardwarePresence } from '~/modules/settings/_graphql/subscriptionPresenceEvents';

export const PresenceProvider = ({ children }: React.PropsWithChildren) => {
  const { members: hardwareMembers } = useHardwarePresence();

  const value = React.useMemo(() => ({ hardwareMembers }), [hardwareMembers]);

  return (
    <PresenceContext.Provider value={value}>
      {children}
    </PresenceContext.Provider>
  );
};
